import React from "react";
import Tooltip from "../../tooltip/Tooltip";
import MovementVoice from "../MovementVoice";
import { Fragment } from "react";
import Info from "../../../assets/img/utils/info.svg"
import './HeaderPanel.scss';
import IconCloseButton from "../IconCloseButton";
import GLOBAL from "../../../global";
import {isMobileDevice} from "../../../utils/Utils";
import MobileAppSuggestions from "../../MobileAppSuggestions/MobileAppSuggestions";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const HeaderPanel = ({EnableDetailedVoiceInstruction, onChangeDetailedVoiceInstruction, onClickSaveAssessment,
     processingSaveAssessment, setShowPreparationInstructionModal, windowHeaderTitle}) => {
    const { isMobileAppSuggestionEnabled, isExamineticsEnabled } = useTenantFeatures();

    return (
        <>
            {
                (isMobileAppSuggestionEnabled && isMobileDevice()) && <MobileAppSuggestions/>
            }

            <div className="header-panel">
                <div  className="header-panel__element header-panel--font-size-18">
                    <p>{isExamineticsEnabled ? (windowHeaderTitle || "Functional Screening") : "Biometric Movements"}</p>

                    <img id="emma-work-best-info" src={Info} alt="Information"/>
                    <Tooltip
                        placement="bottom"
                        target="emma-work-best-info">
                        <span style={{width: "500px"}}>EMMA works best with Google Chrome or Microsoft Edge as your web browser.</span>
                    </Tooltip>
                </div>
                <div  className="header-panel__element header-panel--emma-work-best header-panel--font-size-18">
                    EMMA works best with &nbsp; <a className="header-panel__link" href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> &nbsp;or&nbsp; <a className="header-panel__link" href="https://www.microsoft.com/en-us/edge?form=MA13FJ" target="_blank">Microsoft Edge</a> &nbsp;as your web browser.
                </div>

                <div  className="header-panel__element2 header-panel--font-size-18 ">
                    <div className="header-panel__topbar-wrapper">
                        <button className="header-panel__prep-guide-btn" onClick={() => setShowPreparationInstructionModal(true)}>
                            {/*<span><img className='movement-modal-video-unmute-icon' src={VideoUnmute} alt="video unmute"/></span>*/}
                            <span className="header-panel__instruction-title header-panel--font-size-18">Prep Guide</span>
                        </button>
                    </div>

                    {!isExamineticsEnabled && (
                        <MovementVoice isAudioPlayEnabled={EnableDetailedVoiceInstruction} onChangeAudioPlay={onChangeDetailedVoiceInstruction}/>
                    )}
                    {/*<div className="kt-header__topbar-wrapper appoinment-btn">*/}
                    {/*    <button className="movement-save-close bg-color-green" onClick={() => showAppointmentPop(true)}>*/}
                    {/*        <span><img className='movement-modal-request-teleme-icon' src={RequestTelemedicine} alt="video unmute"/></span>*/}
                    {/*        <span className="pl-2 movement-modal-request-teleme-text">Request Telemedicine</span>*/}
                    {/*    </button>*/}
                    {/*</div>*/}

                    <button className="save-and-close-btn" onClick={onClickSaveAssessment}>
                        {processingSaveAssessment ? (
                            <i className="fa fa-spinner fa-spin"/>
                        ) : (
                            <IconCloseButton/>
                        )
                        }
                    </button>
                </div>
            </div>
        </>
    );
}

export default HeaderPanel;
